<template>
  <div>
    <rc-data-table
      ref="rcTable"
      :data="data"
      :but="rcButList"
      :delete-api="deleteApi"
      :form="{
        form,
        data: formData,
        formItem
      }"
      :columns="tableColumns || column || tableColumns"
      :api="api"
      :params="params"
      :dialog="dialog1 || dialog"
    >
    </rc-data-table>
  </div>
</template>

<script>
import userApi from "@/api/user/user";
// import { emitFun } from '@/utils';
export default {
  name: "Test",
  data() {
    return {
      visible: false,
      form: {
        inline: true,
        closeLayout: true
      },
      // formData: {
      //   search: ''
      // },
      formItem: [{
        component: "rc-search",
        prop: "name",
        span: 6
      }],
      formData: {
        name: "",
        name1: "",
        name2: ""
      },
      // formItem: [{
      //   component: 'rc-input',
      //   label: '群名称',
      //   placeholder: '请输入名称',
      //   prop: 'name',
      //   span: 8
      // }, {
      //   component: 'rc-select',
      //   label: '主组织',
      //   placeholder: '请选择主组织',
      //   prop: 'name1',
      //   descLabel: '选择后不可更改，请谨慎选择',
      //   span: 8,
      //   svgIcon: 'hint',
      //   options: [{
      //     value: 'value',
      //     label: 'label'
      //   }, {
      //     value: 'value--1',
      //     label: 'label--1'
      //   }],
      //   slotStyle: {
      //     marginLeft: '8px',
      //     fontSize: '12px',
      //     color: 'rgb(158, 165, 178)',
      //     fontWeight: 'normal'
      //   },
      //   svgStyle: {
      //     fontSize: '18px',
      //     verticalAlign: 'middle'
      //   }
      // }, {
      //   component: 'rc-input',
      //   label: '描述',
      //   placeholder: '请输入内容',
      //   prop: 'name2',
      //   type: 'textarea',
      //   slotStyle: {
      //     marginLeft: '8px',
      //     fontSize: '12px',
      //     color: 'rgb(158, 165, 178)',
      //     fontWeight: 'normal'
      //   },
      //   slotLabel: '选填',
      //   span: 8
      // }],
      rcButList: {
        butData: [{
          label: "添加组织",
          prop: "add",
          type: "primary"
        }
        // , {
        //   label: '添加组织1',
        //   prop: 'add1',
        //   type: 'primary'
        // }, {
        //   label: '添加组织1',
        //   prop: 'add2',
        //   type: 'primary'
        // }
        ],
        bottom16: true
      },
      loading: "loading111111",
      column: [

        /*
         * {
         *   prop: "selection",
         *   type: "selection",
         * },
         */
        // {
        //   prop: 'radio',
        //   width: '60',
        //   customer: true,
        //   type: 'radio'
        // },
        {
          prop: "date",
          label: "日期",
          width: "150",
          customer: true
        },
        {
          prop: "axInfo",
          label: "配送信息",
          customer: true,
          children: [
            {
              prop: "name",
              label: "姓名",
              width: "120",
              customer: true
            },
            {
              prop: "address1",
              label: "地址",
              children: [
                {
                  prop: "province",
                  label: "省份",
                  width: "120"
                },
                {
                  prop: "city",
                  label: "市区",
                  width: "120",
                  customer: true
                },
                {
                  prop: "address2",
                  label: "地址",
                  width: "300"
                },
                {
                  prop: "zip",
                  label: "邮编",
                  width: "120"
                }
              ]
            }
          ]
        },
        {
          prop: "address",
          label: "address",
          customer: true
        }
      ],
      tableColumns: [
        {
          prop: "selection",
          type: "selection",
          align: "left"
        },
        // {
        //   prop: 'radio',
        //   width: '40',
        //   customer: true,
        //   type: 'radio'
        // },
        // {
        //   type: 'expand'
        // },
        // {
        //   label: this.$t('user.userName'),
        //   prop: 'username',
        //   type: 'router',
        //   name: 'orgGroupDetail'
        // },
        // {
        //   label: this.$t('user.userName'),
        //   prop: 'username',
        //   width: '150',
        //   fixed: false,
        //   hidden: false
        // },
        {
          label: this.$t("user.displayName"),
          prop: "displayName",
          width: "150",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("user.cellphone"),
          prop: "cellphone",
          width: "150",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("user.email"),
          prop: "email",
          width: "220",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("user.role"),
          prop: "roleName",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("user.isEffect"),
          prop: "effect",
          width: "100",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("user.isLock"),
          prop: "lockStatus",
          width: "100",
          fixed: false,
          hidden: false
        }
      ],
      data: [],
      data1: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
          city: "上海市普陀区",
          province: "上海",
          address2: "上海2",
          zip: "zip"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
          city: "上海市普陀区",
          province: "上海",
          address2: "上海2",
          zip: "zip"
        }
      ],
      search: "",
      api: {
        model: userApi,
        name: "getUserList"
      },
      deleteApi: {
        model: userApi,
        name: "deleteItems"
      },
      params: {
        orgId: "5ed8e02c33e25a1115c6e1b7"
      },
      replaceFields: {
        pageSize: "size",
        pageNum: "page"
      },
      butData: [
        {
          label: "测试",
          prop: "test"
        },
        {
          label: "练习",
          prop: "go"
        }
      ],
      deleteButData: [
        {
          prop: "currentPage",
          type: "text",
          label: "选择本页"
        },
        {
          prop: "reset",
          type: "text",
          label: "重置"
        }
      ],
      deleteDialog: {
        content: {
          title: "1111",
          desc: "666"
        }
      },
      apiTip: {
        delete: {
          success: "success",
          error: "error"
        }
      },
      dialog1: {
        contentType: "data-table",
        width: "800px",
        imgIcon: "success",
        title: "添加组织",
        padding24: false,
        api: {
          model: userApi,
          name: "getUserList"
        },
        // disabled: this.disabled,
        params: {
          orgId: "5ed8e02c33e25a1115c6e1b7"
        },
        // beforeConfirm: this.beforeConfirm,
        // api: {
        //   model: '',
        //   name: ''
        // },
        columns: [
          {
            prop: "selection",
            type: "selection",
            align: "left"
          },
          {
            label: this.$t("user.displayName"),
            prop: "displayName",
            width: "150",
            fixed: false,
            hidden: false
          },
          {
            label: this.$t("user.cellphone"),
            prop: "cellphone",
            width: "150",
            fixed: false,
            hidden: false
          },
          {
            label: this.$t("user.email"),
            prop: "email",
            width: "220",
            fixed: false,
            hidden: false
          },
          {
            label: this.$t("user.role"),
            prop: "roleName",
            fixed: false,
            hidden: false
          }
        ]
      },
      dialog: {
        multiple: true,
        add1: {
          contentType: "data-table",
          width: "800px",
          imgIcon: "success",
          title: "添加组织",
          padding24: false,
          api: {
            model: userApi,
            name: "getUserList"
          },
          // disabled: this.disabled,
          params: {
            orgId: "5ed8e02c33e25a1115c6e1b7"
          },
          // beforeConfirm: this.beforeConfirm,
          // api: {
          //   model: '',
          //   name: ''
          // },
          columns: [
            {
              prop: "selection",
              type: "selection",
              align: "left"
            },
            {
              label: this.$t("user.displayName"),
              prop: "displayName",
              width: "150",
              fixed: false,
              hidden: false
            },
            {
              label: this.$t("user.cellphone"),
              prop: "cellphone",
              width: "150",
              fixed: false,
              hidden: false
            },
            {
              label: this.$t("user.email"),
              prop: "email",
              width: "220",
              fixed: false,
              hidden: false
            },
            {
              label: this.$t("user.role"),
              prop: "roleName",
              fixed: false,
              hidden: false
            }
          ]
        },
        add2: {
          title: "创建组织群",
          contentType: "form",
          imgIcon: "success",
          data: {
            name: "",
            name1: "",
            name2: ""
          },
          formItem: [{
            component: "rc-input",
            label: "群名称",
            placeholder: "请输入名称",
            prop: "name",
            span: 24,
            required: true
          }, {
            component: "rc-select",
            label: "主组织",
            placeholder: "请选择主组织",
            prop: "name1",
            descLabel: "选择后不可更改，请谨慎选择",
            span: 24,
            svgIcon: "hint",
            options: [{
              value: "value",
              label: "label"
            }, {
              value: "value--1",
              label: "label--1"
            }],
            slotStyle: {
              marginLeft: "8px",
              fontSize: "12px",
              color: "rgb(158, 165, 178)",
              fontWeight: "normal"
            },
            svgStyle: {
              fontSize: "18px",
              verticalAlign: "middle"
            }
          }, {
            component: "rc-input",
            label: "描述",
            placeholder: "请输入内容",
            prop: "name2",
            type: "textarea",
            slotStyle: {
              marginLeft: "8px",
              fontSize: "12px",
              color: "rgb(158, 165, 178)",
              fontWeight: "normal"
            },
            slotLabel: "选填",
            span: 24
          }]
        }
      }
    };
  },
  methods: {
    customTable(data) {
      return data.records.slice(0, 3);
    },
    beforeConfirm(obj) {
      return false;
    },
    dialogConfirm() {
      this.visible = true;
      setTimeout(() => {
        this.visible = false;
        this.$refs.rcTable.refresh();
      }, 5000);
    },
    disabled(item) {
      return true;
    },
    confirmClick(item, index, obj) {
      // emitFun({ self: this }, { item, index });
    },
    add1() {
      this.visible = true;
    },
    add2() {
      this.visible = true;
    }
  }
};
</script>

// options: ['value', 'value1', 'value2', 'value3', 'value4', 'value5', 'value6', 'value7', 'value8', 'value9', 'value10', 'value11']
// options: [{
//   label: 'value'
// }, {
//   label: 'value1'
// }]
// replaceFields: {
//   value: 'name',
//   label: 'name'
// },
// showAll: true,
// center: '',
// options: [{
//   value: 'value',
//   label: 'label'
// }, {
//   value: 'value--1',
//   label: 'label--1'
// }]
<style lang="scss">
.test {
  padding: 24px;
}
</style>
